import { render, staticRenderFns } from "./EmergencyInfoForm.vue?vue&type=template&id=1d84f2d3"
import script from "./EmergencyInfoForm.vue?vue&type=script&lang=js"
export * from "./EmergencyInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports